import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { CountryCode } from 'store/user/types/state.types';

type TranslationPath = string; // Например: 'disk.disk_types', 'cpu.types'

const useDynamicTranslation = () => {
  const [t] = useTranslation();
  const countryCode = useSelector((state: RootState) => state.user.country?.code);

  return function getTranslation(translationPath: TranslationPath) {
    const key = translationPath;
    // 1. Пробуем прямой перевод (например, 'disk.disk_types.hdd' → "Стандартный")
    const directTranslation = t(key);
    if (directTranslation && !directTranslation.includes(key)) {
      return directTranslation;
    }

    if (countryCode) {
    // 2. Если перевод — объект (например, nvme: { UZ: "NVME", KZ: "NVME KZ" })
      const translationsObj = t(key, { returnObjects: true }) as Record<CountryCode, string>;
      return translationsObj[countryCode];
    }
    return '';
  };
};
export default useDynamicTranslation;
